module.exports = __webpack_public_path__ + "img/thai.421ad2a.svg";